<template>
	<div class="ds-table-skeleton">
		<div v-for="n in rows" :key="n" class="ds-skeleton ds-skeleton--row" />
	</div>
</template>

<script>
export default {
	name: "OvTableSkeleton",
	props: {
		rows: { type: Number, default: 8 },
	},
};
</script>
